import { Box, createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import React from 'react';
import { ClientDisplayToggle } from '../../../components/form';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        gutterBottom: {
            marginBottom: '0.35em',
            height: '18px',
        },
    })
);

type Props = {
    fieldName: string;
    toggleOnClick?: (field: string) => void;
    toggleVisible?: boolean;
};
export const PrimaryHeader = (props: Props) => {
    let { fieldName, toggleOnClick, toggleVisible } = props;
    const classes = useStyles();
    return (
        <Box className={`d-block lh1 ${classes.gutterBottom}`}>
            <Typography variant="caption" color="primary">
                {fieldName}
            </Typography>
            {toggleOnClick && toggleVisible !== undefined && <ClientDisplayToggle onClick={toggleOnClick} visible={toggleVisible} />}
        </Box>
    );
};
